// 仅用于线上预览，实际使用中可以将此逻辑删除
import qs from 'query-string';
import { isSSR } from './is';
export default function getUrlParams() {
  const params = qs.parseUrl(!isSSR ? window.location.href : '').query;
  console.log('params', params);
  const returnParams = {};
  Object.keys(params).forEach(p => {
    returnParams[p] = params[p];
  });
  return returnParams;
}